import type { Permission } from '../auth/permissions';
import type { MessageKey } from '../i18n/messages';

/**
 * Sol menü — TEK yerde, bildirimsel (SEOAI-47).
 *
 * Her öğe hangi izni gerektirdiğini kendisi söyler; menüyü çizen bileşen
 * filtrelemeyi bilmez. Dağıtılmış `{can && <Link/>}` kontrolleri zamanla
 * birbirinden ayrışır ve biri unutulduğunda kullanıcı yapamayacağı bir sayfaya
 * yönlendirilir.
 */
export type NavItem = {
  to: string;
  labelKey: MessageKey;
  /** Öğenin görünmesi için gereken izin. Yoksa herkese görünür. */
  permission?: Permission;
};

export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/projects', labelKey: 'nav.projects', permission: 'project.view' },
  { to: '/roles', labelKey: 'nav.roles', permission: 'role.view' },
] as const;
